import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';

export const isUnreadCommentsInListViewExperimentEnabled = () => {
	const [expConfig] = UNSAFE_noExposureExp('jira_unread_comments_in_list_view');

	return expConfig.get('isEnabled', false);
};
